import React, { useContext } from "react";
import { RingContext } from "../../../Grandpa";

const Special = () => {
  const [house, setHouse] = useContext(RingContext);
  return (
    <div>
      <h4>Special</h4>
      <p>
        <small>House: {}</small>
        <p>Gift: {house}</p>
        <button onClick={() => setHouse(house + 1)}>Increase</button>
      </p>
    </div>
  );
};

export default Special;
